import type { UUID } from './identifier';

export interface TrainingVideo {
  id: UUID;
  categoryId: UUID;
  name: string;
  description: string;
  url: string;
  thumbnail: string;
}

export interface TrainingVideosCategory {
  name: string;
  title: string;
  subtitle: string;
}

export interface TrainingVideosByCategory {
  category: TrainingVideosCategory;
  trainingVideos: TrainingVideo[];
}

export interface UserTrainingMedia {
  userId: UUID;
  trainingMediaId: UUID;
  startedAt: Date;
  finishedAt: Date;
  createdAt: Date;
}

export enum UserTrainingMediaActionType {
  START = 0,
  FINISH = 1,
}

export type UpdateUserTrainingMediaInput = {
  trainingMediaId: UUID;
  action: UserTrainingMediaActionType;
};

export type TrainingVideoWithCategoryDto = {
  name: string;
  category: string;
};

export type UpdateContactTrainingInfoRequestDto = {
  finishedVideos: TrainingVideoWithCategoryDto[];
  startedVideos: TrainingVideoWithCategoryDto[];
};
